import app from './app/types';
import auth from './auth/types';
import user from './user/types';

export default {
    app,
    auth,
    user
}